import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Button, Message, Dropdown } from "semantic-ui-react";
import _ from "lodash";
import settings from "../../settings";
import api from "../../api";
import {
  getSecQuestions,
  isTokenValid,
  expireSession,
} from "../../actions/auth";

class SecurityQuestionsSetupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        appname: settings.appName,
        qaList: [],
      },
      questionSets: [],
      loading: false,
      options: [],
      errors: { answer: [] },
    };
    this.loadData(props);
  }

  componentWillMount() {
    if (!this.props.isTokenValid()) this.props.expireSession();
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  onChange = (e) => {
    const { data } = this.state;
    data.qaList[Number(e.target.name.split("_")[1])].answer = e.target.value;
    this.setState({
      data,
    });
  };

  onSubmit = () => {
    const errorFound = this.validate(this.state.questionSets);
    if (!errorFound) {
      this.setState({ loading: true });
      this.props
        .submit(this.state.questionSets)
        .then(() => this.setState({ loading: false }))
        .catch((err) => {
          this.setState({ errors: err.response.data.errors, loading: false });
        });
    }
  };

  loadData = (props) => {
    if (props.username) {
      api.user
        .getQaQuestionsList({ usercode: props.username })
        .then((res) => {
          if (res.data.Message === "success") {
            const data = this.state.data;
            const options = [];
            if (res.data.Data && res.data.Data.length > 0) {
              options.push({
                key: 0,
                value: 0,
                text: "",
              });
              _.map(res.data.Data, (question) => {
                options.push({
                  key: question.Id,
                  value: question.Id,
                  text: question.Question,
                });
              });
              this.setState({ options });
            }
            const questionSets = [];
            const errors = [];
            const questionSetCounts = 3;
            for (let i = 0; i < questionSetCounts; i += 1) {
              questionSets.push({
                name: `set${i}`,
                options,
                selected: {},
              });
              errors.push(0);
            }
            this.setState({ data, errors, questionSets });
          }
        })
        .catch((err) => {
          console.log("Unable to fetch security questions", err);
        });
    }
  };

  handleQuestionSelect = (data) => {
    const questionSets = this.state.questionSets;
    const currentQuestionSet = _.find(
      questionSets,
      (q) => q.name === data.name
    );
    currentQuestionSet.selected.id = data.value;
    const questions = [];
    _.forEach(questionSets, (questionSet) => {
      questions.push({ name: questionSet.name, id: questionSet.selected.id });
    });
    _.forEach(questionSets, (questionSet) => {
      const options = _.cloneDeep(this.state.options);
      _.forEach(questions, (question) => {
        if (
          question.name !== questionSet.name &&
          question.id &&
          question.id !== 0
        ) {
          _.remove(options, (o) => o.value === question.id);
        }
      });
      questionSet.options = options;
    });
    const index = parseInt(currentQuestionSet.name.replace("set", ""), 10);
    const errors = this.state.errors;
    if (errors[index] === 1) errors[index] = 0;
    this.setState({ questionSets, errors });
  };

  handleAnswerText = (e) => {
    const questionSets = this.state.questionSets;
    const currentQuestionSet = _.find(
      questionSets,
      (q) => q.name === e.target.name.replace("txt_", "")
    );
    const index = parseInt(currentQuestionSet.name.replace("set", ""), 10);
    const errors = this.state.errors;
    if (errors[index] === 2) errors[index] = 0;
    currentQuestionSet.selected.value = e.target.value;
    this.setState({ questionSets, errors });
  };

  validate = (questionSets) => {
    let errorFound = false;
    const { errors } = this.state;
    _.map(questionSets, (questionSet, index) => {
      if (!questionSet.selected.id || questionSet.selected.id === "") {
        errors[index] = 1;
        errorFound = true;
      } else if (
        !questionSet.selected.value ||
        questionSet.selected.value === 0
      ) {
        errors[index] = 2;
        errorFound = true;
      } else {
        errors[index] = 0;
      }
    });
    this.setState({ errors });
    return errorFound;
  };

  render() {
    const { errors, loading, questionSets } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {(errors.global || this.props.securityQuestionsSetupError) && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global || this.props.securityQuestionsSetupError}</p>
          </Message>
        )}
        <Form.Field>
          <span>
            Please select questions from the menus below and fill in the
            answers.
          </span>
          <br />
          <br />
          <span>Hints:</span>
          <ul>
            <li>
              Choose the questions for which you have a single, short answer.
            </li>
            <li>
              Try to keep the answers short, so you will be able to recall them
              later exactly the way you entered them.
            </li>
            <li>Double-check for accuracy such as misspellings.</li>
          </ul>
        </Form.Field>
        {questionSets.length > 0 &&
          _.map(questionSets, (questionSet, index) => (
            <div key={`ques_${questionSet.name}`}>
              <Dropdown
                key={`dd_${questionSet.name}`}
                fluid
                search
                selectOnBlur={false}
                selection
                id={questionSet.name}
                options={questionSet.options}
                name={questionSet.name}
                placeholder={"Please select the question"}
                label={questionSet.FieldLabel}
                onChange={(e, data) => this.handleQuestionSelect(data)}
              />
              {errors[index] === 1 ? (
                <span className={"red-text"}>Please select the question</span>
              ) : (
                <br />
              )}
              <input
                key={`tx_${questionSet.name}`}
                type={"text"}
                name={`txt_${questionSet.name}`}
                placeholder={"Please answer the question"}
                onChange={(e) => this.handleAnswerText(e)}
              />
              {errors[index] === 2 ? (
                <span className={"red-text"}>{`Answer can't be empty`}</span>
              ) : (
                <br />
              )}
              <br />
            </div>
          ))}

        {questionSets.length > 0 && (
          <Button className="padding-top-20" primary>
            Submit All
          </Button>
        )}
      </Form>
    );
  }
}

export default connect(null, {
  getSecQuestions,
  isTokenValid,
  expireSession,
})(SecurityQuestionsSetupForm);



// WEBPACK FOOTER //
// ./src/components/forms/SecurityQuestionsSetupForm.js